import React, { Component } from "react";
import AsideNavbar from "../components/navbars/AsideNavbar";
import Navbars from "../components/navbars/Navbars";
import * as Cookies from "es-cookie";
import { marked } from "marked";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import ShimmerLoader from "../components/preloader/ShimmerLoader";

// --- GraphQL Query ---
const FETCH_SAMPLE_QUESTIONS = gql`
  query ($id: Int) {
    getSampleAiQuestions(id: $id) {
      exam
      chapter
      class
      subject
      is_foundation
      answer
    }
  }
`;

class AiTutorClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggled: Cookies.get("toggle") || "wrapper",
      question: "",
      answer: "",
      context: "",
      loading: false,
      errorMsg: "",
      suggestions: [],
      showSuggestions: false,
      history: [],
      loadingMessageIndex: 0,
      activeTab: "custom",
      loadingMessages: [
        "Generating your genius answer...",
        "Crunching some AI magic...",
        "Cooking up knowledge for you...",
        "Hold tight! Answer incoming...",
      ],
      selectedClass: "",
      selectedExam: "",
      selectedSubject: "",
      showChapterList: false,
      showFoundation: false,
      selectedChapter: null,
      chapters: [],
      apiQuestions: [],
    };
  }

  componentDidMount() {
    const savedHistory = JSON.parse(localStorage.getItem("ai_tutor_history")) || [];
    this.setState({ history: savedHistory });
  }

  componentWillUnmount() {
    clearInterval(this.loadingInterval);
  }

  componentDidUpdate(prevProps, prevState) {
    const { getSampleAiQuestions } = this.props;

    // Update apiQuestions & chapters only when Apollo data actually changes
    if (
      getSampleAiQuestions?.getSampleAiQuestions &&
      prevProps.getSampleAiQuestions?.getSampleAiQuestions !==
      getSampleAiQuestions.getSampleAiQuestions
    ) {
      const apiData = getSampleAiQuestions.getSampleAiQuestions || [];
      const chapters = [
        ...new Set(apiData.map((q) => q.chapter).filter((c) => c !== null && c !== undefined)),
      ];

      // Only set state when data differs to avoid render loops
      if (
        JSON.stringify(apiData) !== JSON.stringify(this.state.apiQuestions) ||
        JSON.stringify(chapters) !== JSON.stringify(this.state.chapters)
      ) {
        this.setState({ apiQuestions: apiData, chapters });
      }
    }

    // Reset selections once when switching back to custom tab
    if (prevState.activeTab !== this.state.activeTab && this.state.activeTab === "custom") {
      this.setState({
        selectedClass: "",
        selectedExam: "",
        selectedSubject: "",
        showChapterList: false,
        selectedChapter: null,
      });
    }
  }

  // --- Helpers ---
  // Only cycle messages while an answer is loading: every tick re-renders the page, and the
  // <MathJax dynamic> blocks re-typeset on each render, which kept the page busy all the time.
  startLoadingMessageCycle = () => {
    clearInterval(this.loadingInterval);
    this.loadingInterval = setInterval(() => {
      this.setState((prev) => ({
        loadingMessageIndex: (prev.loadingMessageIndex + 1) % prev.loadingMessages.length,
      }));
    }, 2000);
  };

  stopLoadingMessageCycle = () => {
    clearInterval(this.loadingInterval);
    this.loadingInterval = null;
  };

  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    const newToggle = toggled === "wrapper" ? "wrapper sidebar-enable" : "wrapper";
    this.setState({ toggled: newToggle });
    Cookies.set("toggle", newToggle);
  };

  // --- AI Tutor Handlers ---
  fetchSuggestions = (text) => {
    if (!text || text.length < 2) {
      this.setState({ suggestions: [], showSuggestions: false });
      return;
    }
    const allSuggestions = [
      "What is Newton's second law?",
      "Explain photosynthesis process.",
      "Define Pythagoras theorem.",
      "What is the speed of light?",
      "Describe the process of mitosis?",
      "Who discovered gravity?",
      "Explain the theory of relativity?",
      "What is an atom?",
      "How does a rainbow form?",
    ];
    const filtered = allSuggestions
      .filter((s) => s.toLowerCase().includes(text.toLowerCase()))
      .slice(0, 10);
    this.setState({ suggestions: filtered, showSuggestions: filtered.length > 0 });
  };

  handleInputChange = (e) => {
    const question = e.target.value;
    this.setState({ question });
    this.fetchSuggestions(question);
  };

  handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const { question, history } = this.state;
    if (!question.trim()) return;

    const cached = history.find((item) => item.question.toLowerCase() === question.toLowerCase());
    if (cached) {
      this.setState({
        answer: cached.answer,
        errorMsg: "",
        context: cached.context || "",
        loading: false,
        activeTab: "ai",
      });
      return;
    }

    this.setState({ loading: true, errorMsg: "", answer: "", context: "", showSuggestions: false, loadingMessageIndex: 0 });
    this.startLoadingMessageCycle();

    try {
      // const response = await fetch("https://www.mypartydashboard.com/PSA/WebService/askMe", {

    const response = await fetch("https://ai.rizee.in/generalanswer", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question }),
      });
      // const data = await response.json();



  const text = await response.text(); // ✅ FIX

  const data = { answer: text };
        if (data.answer) {
        const parsedAnswer = marked.parse(data.answer);
        const newHistory = [
          { question, answer: parsedAnswer, context: data.context || "", timestamp: Date.now() },
          ...history,
        ].slice(0, 100);
        localStorage.setItem("ai_tutor_history", JSON.stringify(newHistory));
        this.setState({ answer: parsedAnswer, history: newHistory, activeTab: "ai" });
      } else {
        this.setState({ errorMsg: data.error || "Unexpected response from server." });
      }
    } catch (err) {
      this.setState({ errorMsg: err.message || "Network error" });
    } finally {
      this.stopLoadingMessageCycle();
      this.setState({ loading: false });
    }
  };

  handleResetAIResponse = () => {
    this.setState({ question: "", answer: "", context: "", errorMsg: "", showSuggestions: false });
  };

  handleHistoryClick = (item) => {
    this.setState({
      question: item.question,
      answer: item.answer,
      context: item.context || "",
      errorMsg: "",
      activeTab: "ai",
    });
  };

  handleDeleteHistory = (index) => {
    const updatedHistory = [...this.state.history];
    updatedHistory.splice(index, 1);
    localStorage.setItem("ai_tutor_history", JSON.stringify(updatedHistory));
    this.setState({ history: updatedHistory });
  };

  // --- Render helpers ---
  renderTopHeadingWithTabs() {
    const { activeTab } = this.state;
    const tabs = [
      { id: "ai", icon: "🤖", title: "AI Tutor" },
      { id: "custom", icon: "⚙️", title: "Custom" },
      { id: "history", icon: "📜", title: "History" },
    ];

    return (
      <div style={{ position: "relative", marginBottom: "25px", height: "50px" }}>
        <h1 style={{ ...styles.title, margin: 0, textAlign: "center", lineHeight: "50px" }}>
          Smart Study Tour
        </h1>

        <div style={{ position: "absolute", right: 0, top: 0, display: "flex", gap: "12px", height: "100%", alignItems: "center" }}>
          {tabs.map((tab) => (
            <div
              key={tab.id}
              onClick={() => this.setState({ activeTab: tab.id })}
              style={{
                ...styles.tabIcon,
                background: activeTab === tab.id ? "linear-gradient(135deg,#4f46e5,#3b82f6)" : "#f3f4f6",
                color: activeTab === tab.id ? "white" : "#111",
              }}
              title={tab.title}
            >
              {tab.icon}
            </div>
          ))}
        </div>
      </div>
    );
  }


  renderContent() {
    const {
      activeTab,
      question,
      suggestions,
      showSuggestions,
      loading,
      answer,
      errorMsg,
      history,
      loadingMessages,
      loadingMessageIndex,
      selectedClass,
      selectedExam,
      selectedSubject,
      showChapterList,
      selectedChapter,
      showFoundation,
      chapters,
      apiQuestions,
    } = this.state;

    const subjectsPerClass = {
      "11": { JEE: ["Physics", "Chemistry", "Maths"], NEET: ["Botany", "Physics", "Chemistry", "Zoology"] },
      "12": { JEE: ["Physics", "Chemistry", "Maths"], NEET: ["Botany", "Physics", "Chemistry", "Zoology"] },
    };
    const exams = ["JEE", "NEET"];

    // --- CUSTOM TAB ---
    if (activeTab === "custom") {
      const romanToNumber = { XI: "11", XII: "12" };

      // Common match function for filtering
      const matchCommon = (item) => {
        const normalizedClass = romanToNumber[item.class] || item.class;
        const matchesExam = item.exam?.trim().toLowerCase() === selectedExam?.trim().toLowerCase();
        const matchesSubject = item.subject?.trim().toLowerCase() === selectedSubject?.trim().toLowerCase();
        const matchesClass = normalizedClass === selectedClass;
        return matchesExam && matchesSubject && matchesClass;
      };

      // ✅ Filters
      const filteredOverviewData = apiQuestions.filter(
        (item) => matchCommon(item) && item.is_foundation === 0 && (item.chapter === null || item.chapter === "")
      );

      const filteredFoundationData = apiQuestions.filter(
        (item) => matchCommon(item) && item.is_foundation === 1 && (item.chapter === null || item.chapter === "")
      );

      const filteredChaptersData = apiQuestions.filter(
        (item) => matchCommon(item) && item.is_foundation === 0 && item.chapter !== null && item.chapter !== ""
      );

      const uniqueChapters = [...new Set(filteredChaptersData.map((item) => item.chapter))];
      const selectedChapterData =
        filteredChaptersData.find((item) => item.chapter === this.state.selectedChapter) || null;

      return (
        <div style={styles.customContainer}>
          {/* SELECTORS */}
          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "15px", alignItems: "flex-start" }}>
            {/* CLASS */}
            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <div style={{ fontWeight: 600 }}>Class:</div>
              <div style={{ display: "flex", gap: "8px" }}>
                {Object.keys(subjectsPerClass).map((cls) => (
                  <button
                    key={cls}
                    onClick={() =>
                      this.setState({
                        selectedClass: cls,
                        selectedExam: "",
                        selectedSubject: "",
                        showChapterList: false,
                        selectedChapter: null,
                        showFoundation: false,
                        answer: "",
                        errorMsg: "",
                      })
                    }
                    style={{
                      ...styles.smallButton,
                      border: selectedClass === cls ? "2px solid #4f46e5" : "1px solid #ccc",
                      background: selectedClass === cls ? "#e0e7ff" : "#f9f9fb",
                      minWidth: "60px",
                    }}
                  >
                    {cls}th
                  </button>
                ))}
              </div>
            </div>

            {/* EXAM */}
            {selectedClass && (
              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                <div style={{ fontWeight: 600 }}>Exam:</div>
                <div style={{ display: "flex", gap: "8px" }}>
                  {exams.map((exam) => (
                    <button
                      key={exam}
                      onClick={() =>
                        this.setState({
                          selectedExam: exam,
                          selectedSubject: "",
                          showChapterList: false,
                          selectedChapter: null,
                          showFoundation: false,
                          answer: "",
                          errorMsg: "",
                        })
                      }
                      style={{
                        ...styles.smallButton,
                        border: selectedExam === exam ? "2px solid #f59e0b" : "1px solid #ccc",
                        background: selectedExam === exam ? "#fbbf24" : "white",
                        color: selectedExam === exam ? "#fff" : "#111",
                        minWidth: "60px",
                      }}
                    >
                      {exam}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* SUBJECT */}
            {selectedClass && selectedExam && (
              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                <div style={{ fontWeight: 600 }}>Subject:</div>
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  {subjectsPerClass[selectedClass][selectedExam].map((sub) => (
                    <button
                      key={sub}
                      onClick={() =>
                        this.setState({
                          selectedSubject: sub,
                          showChapterList: false,
                          showFoundation: false,
                          selectedChapter: null,
                          answer: "",
                          errorMsg: "",
                        })
                      }
                      style={{
                        ...styles.smallButton,
                        border: selectedSubject === sub ? "2px solid #10b981" : "1px solid #ccc",
                        background: selectedSubject === sub ? "#34d399" : "white",
                        color: selectedSubject === sub ? "#fff" : "#111",
                        minWidth: "60px",
                      }}
                    >
                      {sub}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* TOGGLE BUTTONS */}
          {selectedSubject && (
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginBottom: "10px" }}>
              <button
                style={{
                  ...styles.smallButton,
                  background: !showChapterList && !showFoundation ? "#4f46e5" : "white",
                  color: !showChapterList && !showFoundation ? "white" : "#111",
                }}
                onClick={() => this.setState({ showChapterList: false, showFoundation: false, selectedChapter: null })}
              >
                🧠 Subject Study Mechanism
              </button>
              <button
                style={{
                  ...styles.smallButton,
                  background: !showChapterList && showFoundation ? "#4f46e5" : "white",
                  color: !showChapterList && showFoundation ? "white" : "#111",
                }}
                onClick={() => this.setState({ showChapterList: false, showFoundation: true, selectedChapter: null })}
              >
                🧩 Foundation Path
              </button>
              <button
                style={{
                  ...styles.smallButton,
                  background: showChapterList ? "#4f46e5" : "white",
                  color: showChapterList ? "white" : "#111",
                }}
                onClick={() => this.setState({ showChapterList: true, showFoundation: false, selectedChapter: null })}
              >
                📘 Chapter-Wise Study Mechanism
              </button>
            </div>
          )}

          {/* OVERVIEW */}
          {selectedSubject && !showChapterList && !showFoundation && !selectedChapter && (
            <div>
              {filteredOverviewData.length > 0 ? (
                filteredOverviewData.map((item, index) => (
                  <div key={index} style={styles.outputCard}>
                    <div style={styles.questionBox}>
                      <strong>📘 {item.subject} - Overview</strong>
                    </div>
                    <div style={styles.answerBox}>
                      <MathJax dynamic>
                        <div
                          style={styles.answerContent}
                          dangerouslySetInnerHTML={{
                            __html: (marked.parse(item?.answer || "") || "<p style='color: #777;'>No answer available.</p>").replace(/\n/g, "")
                          }}
                        />
                      </MathJax>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ color: "#555" }}>No overview data found.</div>
              )}
            </div>
          )}

          {/* FOUNDATION */}
          {selectedSubject && !showChapterList && showFoundation && !selectedChapter && (
            <div>
              {filteredFoundationData.length > 0 ? (
                filteredFoundationData.map((item, index) => (
                  <div key={index} style={styles.outputCard}>
                    <div style={styles.questionBox}>
                      <strong>📗 {item.subject} - Foundation</strong>
                    </div>
                    <div style={styles.answerBox}>
                      <MathJax dynamic>
                        <div
                          style={styles.answerContent}
                          dangerouslySetInnerHTML={{
                            __html: (marked.parse(item?.answer || "") || "<p style='color: #777;'>No answer available.</p>").replace(/\n/g, "")
                          }}
                        />
                      </MathJax>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ color: "#555" }}>No foundation data found.</div>
              )}
            </div>
          )}

          {showChapterList && !selectedChapter && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px", marginTop: 8 }}>
              {uniqueChapters.length > 0 ? (
                <div style={styles.outputCard}>
                  <div style={styles.questionBox}>
                    <strong>📘 Chapters</strong>
                  </div>

                  <div style={{ display: "flex", flexWrap: "wrap", gap: "15px", marginTop: "10px" }}>
                    {uniqueChapters.map((ch) => (
                      <div
                        key={ch}
                        onClick={() => this.setState({ selectedChapter: ch })}
                        style={{
                          flex: "1 1 calc(33.33% - 15px)", // ✅ Two cards per row
                          background: "#fff",
                          padding: "20px",
                          borderRadius: "12px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                          textAlign: "center",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          border: selectedChapter === ch ? "2px solid #4f46e5" : "1px solid #ddd",
                          fontWeight: 600,
                          color: selectedChapter === ch ? "#4f46e5" : "#111",
                        }}
                      >
                        {ch}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div style={{ color: "#555" }}>No chapters available.</div>
              )}
            </div>
          )}


          {/* SELECTED CHAPTER */}
          {selectedChapter && (
            <div style={{ marginTop: "12px" }}>
              <button
                style={{ ...styles.smallButton, background: "#ef4444", color: "white" }}
                onClick={() => this.setState({ selectedChapter: null })}
              >
                ← Back
              </button>

              <div style={{ marginTop: 10 }}>
                {selectedChapterData ? (
                  <div style={{ marginTop: "10px", padding: "15px", background: "#fff", borderRadius: 10 }}>
                    <MathJax dynamic>
                      <div
                        style={styles.answerContent}
                        dangerouslySetInnerHTML={{
                          __html: (marked.parse(selectedChapterData?.answer || "") || "<p style='color: #777;'>No answer available.</p>").replace(/\n/g, "")
                        }}
                      />
                    </MathJax>
                  </div>
                ) : (
                  <div style={{ marginTop: 10, color: "#555" }}>No data found for this chapter.</div>
                )}
              </div>
            </div>
          )}
        </div>
      );
    }

    // --- HISTORY TAB ---
    if (activeTab === "history") {
      return (
        <div style={styles.historyPanel}>
          {history.length > 0 ? (
            history.map((item, i) => (
              <div key={i} style={styles.historyCard}>
                <div style={styles.historyText} onClick={() => this.handleHistoryClick(item)}>
                  {item.question}
                </div>
                <button onClick={() => this.handleDeleteHistory(i)} style={styles.cancelBtn}>
                  ❌
                </button>
              </div>
            ))
          ) : (
            <div style={{ textAlign: "center", color: "#555" }}>No previous questions.</div>
          )}
        </div>
      );
    }

    // --- AI TUTOR TAB ---
    return (
      <>
        <form onSubmit={this.handleSubmit} style={styles.form}>
          <div style={styles.inputWrapper}>
            <input
              type="text"
              placeholder="Ask a question..."
              value={question}
              onChange={this.handleInputChange}
              style={styles.input}
            />
            <button type="submit" style={styles.askBtn}>Ask</button>
            <button type="button" style={styles.resetResponseBtn} onClick={this.handleResetAIResponse}>Reset</button>
          </div>

          {showSuggestions && (
            <ul style={styles.suggestionList}>
              {suggestions.map((s, i) => (
                <li key={i} onClick={() => this.setState({ question: s, showSuggestions: false })} style={{ padding: "8px", cursor: "pointer" }}>
                  {s}
                </li>
              ))}
            </ul>
          )}
        </form>

        {loading && (
          <div style={styles.outputCard}>
            <div style={styles.questionBox}>
              <strong>❓ Question:</strong> {question}
            </div>
            <div style={styles.answerBox}>
              {/* Shimmer skeleton while the AI composes the answer */}
              <div className="rz-shimmer" style={{ height: "14px", width: "92%", borderRadius: "6px", marginBottom: "12px" }} />
              <div className="rz-shimmer" style={{ height: "14px", width: "100%", borderRadius: "6px", marginBottom: "12px" }} />
              <div className="rz-shimmer" style={{ height: "14px", width: "96%", borderRadius: "6px", marginBottom: "12px" }} />
              <div className="rz-shimmer" style={{ height: "14px", width: "78%", borderRadius: "6px", marginBottom: "12px" }} />
              <div className="rz-shimmer" style={{ height: "14px", width: "88%", borderRadius: "6px", marginBottom: "16px" }} />
              <div style={styles.loadingText}>{loadingMessages[loadingMessageIndex]}</div>
            </div>
          </div>
        )}

        {!loading && (answer || errorMsg) && (
          <div style={styles.outputCard}>
            <div style={styles.questionBox}>
              <strong>❓ Question:</strong> {question}
            </div>
            <div style={styles.answerBox}>
              <MathJax dynamic>
                <div style={styles.answerContent} dangerouslySetInnerHTML={{ __html: errorMsg ? `<p style="color:red">${errorMsg}</p>` : answer }} />
              </MathJax>
            </div>
          </div>
        )}
      </>
    );
  }

  render() {
    const { getSampleAiQuestions } = this.props;
    // Keep the navbars and side menu on screen while the sample questions load;
    // only the content area shows a shimmer.
    const samplesLoading = !getSampleAiQuestions || !getSampleAiQuestions.getSampleAiQuestions;

    // Ensure initial apiQuestions/chapter state populated if not already (safe guard)
    // (componentDidUpdate handles normal updates; this is just a safety in case props already present)
    if (!samplesLoading && this.state.apiQuestions.length === 0 && getSampleAiQuestions.getSampleAiQuestions.length > 0) {
      const apiData = getSampleAiQuestions.getSampleAiQuestions || [];
      const chapters = [
        ...new Set(apiData.map((q) => q.chapter).filter((c) => c !== null && c !== undefined)),
      ];
      // Directly set without causing render loop since called only during initial render if needed
      // (setState here is safe because it won't be repeatedly called; componentDidUpdate has guards)
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ apiQuestions: apiData, chapters });
    }

    const config = {
      loader: { load: ["[tex]/html"] },
      tex: { inlineMath: [['$', '$'], ['\\(', '\\)']], displayMath: [['$$', '$$'], ['\\[', '\\]']] },
      svg: { fontCache: 'global' }
    };


    return (
      <div className={this.state.toggled}>
        <div className="header-area">
          <Navbars onClick={this.menuToggler} />
        </div>
        <div className="main-wrapper">
          <AsideNavbar onClick={this.menuToggler} />
          <MathJaxContext config={config}>
            <div style={styles.page}>
              {samplesLoading ? (
                <ShimmerLoader />
              ) : (
                <>
                  {this.renderTopHeadingWithTabs()}
                  {this.renderContent()}
                </>
              )}
            </div>
          </MathJaxContext>
        </div>
      </div>
    );
  }
}

// --- Styles ---
const styles = {
  page: { padding: "30px", background: "#f9f9fb", minHeight: "100vh" },
  title: { color: "#1e3a8a", fontSize: "2rem", fontWeight: 700 },
  tabIcon: {
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "1.2rem",
  },
  customContainer: { maxWidth: "1000px", margin: "0 auto", background: "white", padding: "30px", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)" },
  smallButton: { padding: "6px 12px", borderRadius: "6px", border: "1px solid #ccc", cursor: "pointer", fontWeight: 600 },
  form: { textAlign: "center", marginBottom: "20px" },
  inputWrapper: { position: "relative", width: "60%", margin: "0 auto", display: "flex", gap: "8px" },
  input: { flex: 1, padding: "12px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "8px" },
  askBtn: { padding: "0 20px", background: "linear-gradient(135deg,#4f46e5,#3b82f6)", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: 600 },
  resetResponseBtn: { padding: "0 14px", background: "#ef4444", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: 600 },
  suggestionList: { listStyle: "none", padding: 0, margin: "10px auto", width: "60%", background: "white", borderRadius: "8px", border: "1px solid #ddd" },
  spinnerContainer: { textAlign: "center", marginTop: "30px" },
  spinner: { display: "flex", justifyContent: "center", gap: "10px" },
  spinnerDot: { width: "14px", height: "14px", borderRadius: "50%", background: "linear-gradient(45deg,#4f46e5,#3b82f6,#10b981,#06b6d4)", animation: "bounce 1.2s infinite ease-in-out" },
  loadingText: { marginTop: "10px", fontWeight: 700, fontSize: "1rem", background: "linear-gradient(to right,#4f46e5,#10b981)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" },
  historyPanel: { maxWidth: "800px", margin: "0 auto", display: "flex", flexDirection: "column", gap: "10px" },
  historyCard: { padding: "12px 16px", background: "#eef2ff", borderRadius: "8px", display: "flex", justifyContent: "space-between", alignItems: "center" },
  historyText: { cursor: "pointer", flex: 1 },
  cancelBtn: { border: "none", background: "transparent", cursor: "pointer" },
  outputCard: { background: "#fff", borderRadius: "12px", boxShadow: "0 8px 24px rgba(0,0,0,0.12)", padding: "20px", width: "100%", margin: "20px 0", borderLeft: "6px solid #4f46e5", display: "flex", flexDirection: "column", gap: "12px", fontFamily: "'Segoe UI', sans-serif" },
  questionBox: { background: "#eef2ff", padding: "10px 14px", borderRadius: "8px", fontWeight: 600, color: "#1e3a8a" },
  answerBox: { background: "#f3f4f6", padding: "12px 14px", borderRadius: "8px", color: "#111", maxHeight: "450px", overflowY: "auto" },
  answerContent: { lineHeight: "1.5rem", fontSize: "0.95rem" },
};

export default compose(
  graphql(FETCH_SAMPLE_QUESTIONS, {
    name: "getSampleAiQuestions",
    options: { variables: { id: 1 }, fetchPolicy: "cache-first" },
  })
)(withRouter(AiTutorClass));
